
import {Component, Mixins, Prop} from "vue-property-decorator";
import {mask} from "vue-the-mask";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({
    directives: {
        mask
    }
})
export default class YevmiyeNumarasi extends Mixins(SimpleInputMixin) {
    @Prop() label !: string;
    @Prop() rules !: any;
    @Prop() hideDetails !: string | boolean;
    @Prop() backgroundColor !: string;
    @Prop({default:"####/######"}) maskStr: any;
    @Prop({default: 6}) minLength!: number;

    get isHideDetails() {
        return this.hideDetails || this.hideDetails === "";
    }

  get yevmiyeNoRules(){
    if(this.localValue){
      let rule : any = [];
      if(this.localValue.length < this.minLength){
        rule = [`Minimum ${this.minLength} karakter`];
      }
      return rule;
    }
  }

    validate() {
        this.$emit("value", this.localValue);
    }
}
